import containerFuild from '../html-snippets/container-fuild.js';
import css from '../css-snippets/section-card-cedrow-grid-icons';

const html = `
<div class="container wrap-card">
  <div data-show="false" data-attribute="card-title" class="card-title"></div>
  <div data-attribute="list-item" class="list-item" data-col-per-view="4" style="--col-per-view: 4">
    <div data-attribute="item" class="item-with-icon">
      <div class="wrap-icon">
        <img
          data-attribute="image-item"
          src="https://cdn.skyfastimg.com/images/2026/08/06/image-6a73ef010564100d866da2ed.png"
          alt=""
        />
      </div>
      <div data-attribute="text-item" class="text-item">
        <h2>Fast Shipping</h2>
        <p>On all orders</p>
      </div>
    </div>
    <div data-attribute="item" class="item-with-icon">
      <div class="wrap-icon">
        <img
          data-attribute="image-item"
          src="https://cdn.skyfastimg.com/images/2026/08/06/image-6a73f1508c81713aa3824188.png"
          alt=""
        />
      </div>
      <div data-attribute="text-item" class="text-item">
        <h2>30 Days Guarantee</h2>
        <p>Didn't like it? return it</p>
      </div>
    </div>
    <div data-attribute="item" class="item-with-icon">
      <div class="wrap-icon">
        <img
          data-attribute="image-item"
          src="https://cdn.skyfastimg.com/images/2026/08/06/image-6a73f16faecaea762708dcb9.png"
          alt=""
        />
      </div>
      <div data-attribute="text-item" class="text-item">
        <h2>Secure Payment</h2>
        <p>Secure and trusted credit card provider</p>
      </div>
    </div>
    <div data-attribute="item" class="item-with-icon">
      <div class="wrap-icon">
        <img
          data-attribute="image-item"
          src="https://cdn.skyfastimg.com/images/2026/08/06/image-6a73f18b051a6fcaadff8dd4.png"
          alt=""
        />
      </div>
      <div data-attribute="text-item" class="text-item">
        <h2>Happy Customers</h2>
        <p>Thousands of happy customers worldwide</p>
      </div>
    </div>
  </div>
</div>
`;

export default containerFuild(html, css, {
  backgroundColor: '#ffffff',
  textColor: '#00374c',
  topPadding: true,
  bottomPadding: true,
});
